import React from 'react';
import { BREAKPOINTS, Stack, rem, useLang, Alert } from "@manulife/mux";
import { NormalText, PageHeadding } from '../../assets/appStyledComponents';
import LABELS from '../../assets/labels';
import NumberConstants from '../../assets/appStyledComponents/numberConstant.json';
import useWindowSize from '../../customHooks/useWindowSize';
import { useSelector } from 'react-redux';
import Labels from "../../assets/labels";

function IrHeading() {
    const { width: windowWidth } = useWindowSize();
    const isError = useSelector(
        (state) => state.errorReducer?.isError
    );
    const selectedLang = useLang();
    const { num20, num24 } = NumberConstants;
    return (
        <Stack align="flex-start" gap={`${rem(num20)}`} style={{
            maxWidth: `${rem(BREAKPOINTS.DESKTOP_STANDARD)}`,
            padding: windowWidth > BREAKPOINTS.TABLET_PORTRAIT ? `${rem(0)}` : `${rem(0)} ${rem(num24)}`
        }}>
            {isError && <Alert
                className={windowWidth < BREAKPOINTS.MOBILE_STANDARD ? "rtgErrorMessageCardXs" : "rtgErrorMessageCard"}
                variant={Alert.VARIANT.PRIMARY}
                severity={Alert.SEVERITY.ALERT}
                hasCloseButton
            >
                {Labels.errors.apiFailed[selectedLang]}
            </Alert>}
            <PageHeadding role="heading" aria-level="1" >{LABELS.irCalculatorPageHeading[selectedLang]}</PageHeadding>
            <NormalText>{LABELS.irCalculatorDescription[selectedLang]}</NormalText>
        </Stack>
    )
}

export default IrHeading